<template>
    <main>
        <header class="banner solutions pro-solution">
            <div class="container">
                <div class="text-left">
                    <router-link tag="a" to="/solucoes" class="btn btn-viitra-green"><i class="fas fa-chevron-left"></i>Back to solutions</router-link>
                </div>
                <h1>Custom Projects</h1>
                <h4>for high impact business</h4>
            </div>
            <div class="clip-path-one green70">
                <span class="arrow-header"></span>
            </div>
        </header>

        <section class="solution-intro">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                         Needing a custom project for you company? Check the different and many advantages our custom development can bring to your business.
                    </div>
                </div>
            </div>
        </section>

        <section class="solution-items">

            <solution-item v-for="(item, i) of data.solutionItems" :data="item" :number="i + 1" :key="i"></solution-item>

        </section>

        <section class="parallax pro-solution"></section>

        <section class="cta-solutions">
            <div class="container">
                <div class="row">
                    <div class="col-md-3">
                        <router-link tag="a" to="/solucoes/educacionais" class="btn btn-viitra-green"><i class="fas fa-chevron-left"></i> Go to Educational Solutions</router-link>
                    </div>
                    <div class="col-md-6">
                        <h1>want to see<br>more solutions?</h1>
                    </div>
                    <div class="col-md-3">
                        <router-link tag="a" to="/solucoes" class="btn btn-viitra-dark">Back to solutions<i class="fas fa-chevron-right"></i></router-link>
                    </div>
                </div>
            </div>
            <div class="path opacity40"></div>
            <div class="path opacity60"></div>
            <div class="path opacity80"></div>
        </section>

        <section class="cta-solutions mobile">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1>Quer ver <br>mais soluções?</h1>
                    </div>
                    <div class="col-md-12">
                        <router-link tag="a" to="/solucoes/educacionais" class="btn btn-viitra-green"><i class="fas fa-chevron-left"></i> Go to Educational Solutions</router-link>
                    </div>
                    <div class="col-md-12">
                        <router-link tag="a" to="/solucoes" class="btn btn-viitra-dark">Back to solutions<i class="fas fa-chevron-right"></i></router-link>
                    </div>
                </div>
            </div>
            <div class="path opacity40"></div>
            <div class="path opacity60"></div>
            <div class="path opacity80"></div>
        </section>
    </main>
</template>

<script>
    export default {
        data() {
            return {
                data: {
                    solutionItems: [
                        {
                            title: 'Web Systems',
                            description: `
                                 <p>Customized web systems designed and developed by Viitra ensure that the 
                                organizations increases productivity across all sectors and thereby achieve 
                                better return of results and profitability. We are specialized in the main technologies in the market, be they languages, databases, tools, etc.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                src: '/static/images/solutions/custom_projects/pro-figure (1).jpg'
                            },
                        },
                        {
                            title: 'Mobile Applications',
                            description: `
                               <p>We develop apps for smartphones and tablets for the operating system iOS 
                                and Android, according to your need. We design and produce all types of applications,
                                 business, social networking, marketing, communication, music, browsing, utilities, medical, etc.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                src: '/static/images/solutions/custom_projects/pro-figure (2).jpg'
                            },
                        },
                        {
                            title: 'Security',
                            description: `
                                <p>We use encryption techniques, backup scheduling and access control with 
                                login and password to keep your data safe from intrusion. In addition, we host 
                                cloud systems for an even more robust layer of security.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                src: '/static/images/solutions/custom_projects/pro-figure (5).jpg'
                            },
                        },
                        {
                            title: 'Economy',
                            description: `
                                <p>We know that every business has its particularities. Avoid disappointment 
                                and wasted time with generic solutions that do not fully meet your demand. 
                                Situations like this are avoided by designing a custom solution where you make
                                 an investment to meet all (and only) the demands you need.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                src: '/static/images/solutions/custom_projects/pro-figure (6).jpg'
                            },
                        },
                        {
                            title: 'Flexibility',
                            description: `
                                <p>A customized solution ensures that your business will have professional 
                                support that implements the changes that may occur to your business model, 
                                as opposed to a ready system that will not be able to adapt.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                src: '/static/images/solutions/custom_projects/pro-figure (9).jpg'
                            },
                        },
                        {
                            title: 'Mobility',
                            description: `
                                 <p>Another big advantage of opting for a customized cloud-hosted system is 
                                the mobility it provides for its employees. They will be able to access it 
                                from anywhere, while traveling or while serving a customer.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                src: '/static/images/solutions/custom_projects/pro-figure (10).jpg'
                            },
                        },
                        {
                            title: 'Easiness',
                            description: `
                                <p>Generic systems may have complexities that do not fit your demands. 
                                These features will be idle most of the time. A customized system will be 
                                created based on simplicity and focused on the day to day of your business.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                src: '/static/images/solutions/custom_projects/pro-figure (13).jpg'
                            },
                        },
                        {
                            title: 'Easy Maintenance',
                            description: `
                                <p>With cloud hosting, we will immediately give maintenance and support to your
                                 system. This will prevent scheduling for technical visits, where the system 
                                 will be down for maintenance.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                src: '/static/images/solutions/custom_projects/pro-figure (14).jpg'
                            },
                        },
                        {
                            title: 'Processes Automation',
                            description: `
                                <p>We will make your business more agile through our analysis, optimization and 
                                automation of your processes, allowing internal communication between your employees
                                 to be more efficient. A aligned and prepared internal team will make your relationship
                                  with customers better and the productivity gain will be the biggest return.</p>
                            `,
                            imageArea: {
                                type: '',
                                src: ''
                            },
                        },
                    ]
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/solutions/Pro.vue